import { render } from "./Reactivate.vue?vue&type=template&id=0885d042"
import script from "./Reactivate.vue?vue&type=script&lang=js"
export * from "./Reactivate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__